import Common from '../../Common';

const CID = class extends Common {
	browse = (userId: id): CustomResponse<CidAndDid[]> =>
		this.get(`/user/${userId}/cid`)

	force = (userId: id, cidId: id) =>
		this.post(`/user/${userId}/cid/${cidId}/force`)
}

export default CID;
